import styled from 'styled-components';

const EditProfileStyled = styled.div`
  .ant-modal-title {
    font-size: 24px !important;
    line-height: 36px;
    color: #353a45;
    margin: 0;
  }

  .ant-upload-picture-card-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
  }

  .react-tel-input .form-control {
    width: 100%;
  }
`;

export default EditProfileStyled;
